import { render, staticRenderFns } from "./BasicInfo.vue?vue&type=template&id=14b2290b&scoped=true&"
import script from "./BasicInfo.vue?vue&type=script&lang=js&"
export * from "./BasicInfo.vue?vue&type=script&lang=js&"
import style0 from "./BasicInfo.vue?vue&type=style&index=0&id=14b2290b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b2290b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/yx-web-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14b2290b')) {
      api.createRecord('14b2290b', component.options)
    } else {
      api.reload('14b2290b', component.options)
    }
    module.hot.accept("./BasicInfo.vue?vue&type=template&id=14b2290b&scoped=true&", function () {
      api.rerender('14b2290b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Activity/Children/BaseInfoChildren/BasicInfo.vue"
export default component.exports